import * as React from 'react';
import { colors } from '../../../index';

const IconAnalytics = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "-0.155 -0.199 13.942 12.217",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08 9.036H3.83V4.661h1.25v4.375zm2.5 0H6.33v-6.25h1.25v6.25zm2.5 0H8.83v-2.5h1.25v2.5zm1.563 1.313H2.267V1.535h9.376v8.813zm0-10.063H2.267c-.687 0-1.25.563-1.25 1.25v8.75c0 .688.563 1.25 1.25 1.25h9.376c.687 0 1.25-.563 1.25-1.25v-8.75c0-.688-.563-1.25-1.25-1.25z"
  }));
};

export default IconAnalytics;